export default __webpack_public_path__ + "static/media/backButton.89277896.svg";